export const DEFAULT_TOTAL_SEGMENTS = 4;

export const GOAL_TYPE_TEXT = {
	ChannelScheduled: "goals.tutoring_sessions",
	FeedbackCreated: "goals.feedback_submissions",
	ReviewRequestSubmitted: "goals.review_requested",
};
